import { Link, type LinkProps } from '@tanstack/react-router'
import type { ComponentType } from 'react'

import { isActivePath } from '../lib/navigation'

export type NavIcon = ComponentType<{ size?: number; filled?: boolean }>

export interface NavItem {
  to: NonNullable<LinkProps['to']>
  label: string
  icon: NavIcon
}

/**
 * The bottom navigation bar (M3 `ShortNavigationBar`, compact windows only, §11.3): the phone's own four
 * destinations (`MtApp.kt`'s `LeftTabs`/`RightTabs`) plus a 5th "More" (`lib/navigation.ts`'s `BOTTOM_NAV_ITEMS`,
 * owner device test 24 Oct 2026), a pill indicator on the active item, labels always shown. The "+" that used to
 * sit inside the phone's bar is a FAB above it instead (owner decision, §12 #4) — see `Fab.tsx`.
 */
export function BottomNav(props: { items: readonly NavItem[]; pathname: string }) {
  return (
    <nav className="bottom-nav" aria-label="Main">
      {props.items.map((item) => {
        const active = isActivePath(props.pathname, item.to)
        const Icon = item.icon
        return (
          <Link key={item.to} to={item.to} className="bottom-nav-item" aria-current={active ? 'page' : undefined}>
            <span className="bottom-nav-icon">
              <Icon size={24} filled={active} />
            </span>
            {item.label}
          </Link>
        )
      })}
    </nav>
  )
}
